import type { RefCallback, RefObject } from 'react'
import { Input, type InputProps } from 'react-aria-components'
import { cn } from '#utils/cn.ts'
import { getSize, type Rounding, type Size } from '#utils/misc.ts'
import { twm } from '#utils/twm.ts'

type Theme = 'outline' | 'solid' | 'blank'
interface InputFieldProps extends Omit<InputProps, 'size'> {
  className?: string
  fieldRef?: RefObject<HTMLInputElement | null> | RefCallback<HTMLInputElement>
  rounding?: Rounding
  size?: Size
  theme?: Theme
}

const themeClasses = {
  solid:
    'border-0 text-base-8 bg-base-5 placeholder:text-base-8 focus:bg-base-6',
  outline: 'border border-base-6 bg-base-3 outline-none',
  blank: 'border-0 p-0 focus:outline-none bg-transparent',
}

export function InputField({
  className,
  fieldRef,
  rounding = 'all',
  size = 'md',
  theme = 'outline',
  ...props
}: InputFieldProps) {
  return (
    <Input
      {...props}
      className={twm(
        cn(theme !== 'blank' && getSize(size, rounding), themeClasses[theme]),
        className
      )}
      ref={fieldRef}
    />
  )
}
